import styled from '@emotion/styled';
import { Popover } from 'antd';
import { observer } from 'mobx-react-lite';

import { ReactComponent as AppsIcon } from '../../../../components/apps-menu/icons/AppsIcon.svg';
import { theme } from '../../../../theme/theme';
import { MainLayoutApplicationsMenuContent } from './MainLayoutApplicationsMenuContent';
import { type ApplicationsMenuItem } from './MainLayoutApplicationsMenuItem';

import type { ComponentProps, ReactNode } from 'react';

const DEFAULT_MENU_INLINE_SIZE = 330;

const StyledButton = styled.div`
	display: inline-flex;
	gap: 8px;
	align-items: center;
	justify-content: center;
	color: ${theme.colors.purple3};
	border-radius: 6px;
	padding: 8px;
	transition:
		background-color 0.1s,
		color 0.1s;

	&:hover {
		background-color: ${theme.colors.purple6};
		color: ${theme.colors.purple1};
	}
`;

export interface MainLayoutApplicationsMenuProps extends ComponentProps<typeof Popover> {
	readonly items: ReadonlyArray<ApplicationsMenuItem>;
	readonly title?: ReactNode;
	readonly triggerIcon?: ReactNode;
	readonly menuInlineSize?: number;
	readonly onOpen?: () => void;
}

export const MainLayoutApplicationsMenu = observer(function MainLayoutApplicationsMenu({
	items,
	title = 'Applications',
	triggerIcon = <AppsIcon />,
	menuInlineSize = DEFAULT_MENU_INLINE_SIZE,
	onOpen,
	...popoverProps
}: MainLayoutApplicationsMenuProps) {
	if (items.length === 0) {
		return null;
	}

	return (
		<Popover
			{...{
				placement: 'bottomLeft',
				trigger: 'hover',
				styles: { root: { inlineSize: menuInlineSize }, body: { padding: 0 } },
				...popoverProps,
				content: <MainLayoutApplicationsMenuContent {...{ items, title }} />,
			}}
		>
			<StyledButton onMouseEnter={onOpen}>{triggerIcon}</StyledButton>
		</Popover>
	);
});
